import { useMutation } from "@tanstack/react-query";
import { updateFloorPlanMemoDiagram } from "~/_legacy/apis/update-floor-plan-memo-diagram";
import { isNullish } from "~/_legacy/utils/compare";

export const UPDATE_FLOOR_PLAN_MEMO_DIAGRAM_MUTATION_KEY = "updateFloorPlanMemoDiagram";

export function useUpdateFloorPlanMemoDiagram({
  branchUid,
  branchVersionId,
}: {
  branchUid?: string;
  branchVersionId?: number;
}) {
  const { mutateAsync } = useMutation({
    mutationKey: [UPDATE_FLOOR_PLAN_MEMO_DIAGRAM_MUTATION_KEY, branchUid, branchVersionId],
    mutationFn: ({
      floorPlanId,
      memoDiagramId,
      coordinates,
      style,
    }: {
      floorPlanId: number;
      memoDiagramId: number;
      coordinates: { x: number; y: number }[];
      style: { fill?: string; borderColor?: string; opacity: number };
    }) => {
      if (isNullish(branchUid)) {
        throw new Error("Branch uid가 필요합니다.");
      }
      return updateFloorPlanMemoDiagram({
        branchUid,
        branchVersionId,
        floorPlanId,
        memoDiagramId,
        coordinates,
        style,
      });
    },
  });

  return {
    updateFloorPlanMemoDiagram: mutateAsync,
  };
}
